import { render, staticRenderFns } from "./getProduct2.vue?vue&type=template&id=5c73fa16&scoped=true&"
import script from "./getProduct2.vue?vue&type=script&lang=js&"
export * from "./getProduct2.vue?vue&type=script&lang=js&"
import style0 from "./getProduct2.vue?vue&type=style&index=0&id=5c73fa16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73fa16",
  null
  
)

export default component.exports